module.exports = __webpack_public_path__ + "static/media/up-gold.11a8715f.svg";